declare namespace $ {

	export class $mol_icon_history extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=history.view.tree.d.ts.map